import type { SimulateSessionResponse } from '@multirx/shared/types/championship.js';
import {
  archivesDetailHashFromId,
  prepareArchiveReplayFromSimulate,
} from '../raceHistory/archivePostSimulateNav.js';
import { showChampionshipQualCompletionRecaps } from './showChampionshipQualCompletionRecaps.js';
import { showChampionshipSessionResults } from './showChampionshipSessionResults.js';

/**
 * Après simulate : ouvre le replay si `raceHistoryId` est présent,
 * sinon overlay résultats puis récaps qualif.
 */
export function showChampionshipPostSessionFlow(response: SimulateSessionResponse): void {
  const historyId = prepareArchiveReplayFromSimulate(response, 'saisons');
  if (historyId != null) {
    window.location.hash = archivesDetailHashFromId(historyId);
    return;
  }

  showChampionshipSessionResults(response, () => {
    showChampionshipQualCompletionRecaps(response);
  });
}
